export default {
  title: 'AIRPORT - SUGGESTED PICKUP TIME',
  items: {
    ArrivalDomesticDelay: {
      label: 'Airport Pickup: Domestic',
      type: 'integer',
      unit: 'minutes'
    },
    ArrivalInternationalDelay: {
      label: 'Airport Pickup: International',
      type: 'integer',
      unit: 'minutes'
    },
    DepartureDomesticBuffer: {
      label: 'Airport Dropoff: Domestic',
      type: 'integer',
      unit: 'minutes'
    },
    DepartureInternationalBuffer: {
      label: 'Airport Dropoff: International',
      type: 'integer',
      unit: 'minutes'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/airport-suggested-pickup-time.js